import { DocumentSnapshot, DocumentReference } from "firebase/firestore";
import SecureatSnapshot from "../SecureatSnapshot";
import Database from "../Database";
import { toImageKit } from "@/utils/ImageUtils";
import SecureatIllustration from "../utils/SecureatIllustration";

export default class Employee extends SecureatSnapshot {
  active: boolean = true;
  illustration_url: SecureatIllustration | null = null;
  name: string = "";
  surname: string = "";
  role: DocumentReference | null = null;
  completed_communications: DocumentReference[] = [];
  stores: DocumentReference[];
  databases: DocumentReference[];
  password: string | null = null;
  pattern: number[] | null = null;
  using_password: boolean = true;
  old_ref: DocumentReference | null = null;

  constructor(
    ref: DocumentReference,
    name: string,
    surname: string,
    active: boolean,
    illustration_url: SecureatIllustration | null,
    role: DocumentReference | null,
    completed_communications: DocumentReference[],
    stores: DocumentReference[],
    databases: DocumentReference[],
    password: string | null,
    pattern: number[] | null,
    using_password: boolean,
    old_ref: DocumentReference | null
  ) {
    super(ref);
    this.name = name;
    this.surname = surname;
    this.active = active;
    this.illustration_url = illustration_url;
    this.role = role;
    this.completed_communications = completed_communications;
    this.stores = stores;
    this.databases = databases;
    this.password = password;
    this.pattern = pattern;
    this.using_password = using_password;
    this.old_ref = old_ref;
  }

  public static fromFirestore(snapshot: DocumentSnapshot): Employee {
    const data = snapshot.data()!;

    let result = new Employee(
      snapshot.ref,
      data.name,
      data.surname,
      data.active == undefined ? true : data.active,
      data.illustration_url != undefined
        ? SecureatIllustration.fromFirestore(data.illustration_url)
        : null,
      data.role == undefined ? null : data.role,
      data.completed_communications == undefined
        ? []
        : data.completed_communications,
      data.stores == undefined ? [] : data.stores,
      data.databases == undefined ? [] : data.databases,
      data.password == undefined ? null : data.password,
      data.pattern == undefined ? null : data.pattern,
      data.using_password == undefined ? true : data.using_password,
      data.old_ref == undefined ? null : data.old_ref
    );

    return result;
  }

  public toFirestore() {
    return {
      name: this.name,
      surname: this.surname,
      active: this.active,
      illustration_url:
        this.illustration_url != null
          ? this.illustration_url.toFirestore()
          : null,
      role: this.role,
      completed_communications: this.completed_communications,
      stores: this.stores,
      databases: this.databases,
      password: this.password,
      pattern: this.pattern,
      using_password: this.using_password,
      old_ref: this.old_ref,
    };
  }
}
